export default {
  days: ['ئاهد', 'اثنين', 'ثلاثاء', 'اربعاء', 'خميس', 'جمعة', 'سبت'],

  common: {
    save:          'سيمڤن',
    close:         'توتوڤ',
    cancel:        'باتل',
    back:          'کمبالي',
    add:           'تمبه',
    noData:        'تيادا داتا',
    male:          'لاکي-لاکي',
    female:        'ڤرمڤوان',
    error:         'رالت برلاکو',
    studyYear:     (y) => `تاهون ڤلاجارن ${y}`,
    studyYearShort:(y) => `تاهون ${y}`,
    classNo:       (c, r) => `دارجه ${c} بيليک ${r}`,
    studentCount:  (n) => `مريد ${n} ئورڠ`,
    personCount:   (n) => `${n} ئورڠ`,
    active:        'أکتيف',
    withdrawn:     'جوال',
    years:         'تاهون',
  },

  subjectList: {
    pageTitle:        'ماتا ڤلاجرن سايا (باهاڬيان اڬام)',
    noTeaching:       'تيادا ماکلومت ڤڠاجارن',
    colCode:          'کود ماتا ڤلاجرن',
    colName:          'نام ماتا ڤلاجرن',
    colSchedule:      'جدول حصة',
    colAttend:        'ڤريکسا ناما',
    colScore:         'مرک',
    studentListBtn:   'سناراي مريد',
    attendBtn:        'ڤريکسا ناما',
    scoreBtn:         'مرک',
    noStudents:       'تيادا سناراي مريد',
    studentInfo:      'ماکلومت مريد',
    identity:         'ڤريبادي',
    address:          'الامت',
    father:           'بايه',
    mother:           'إيبو',
    guardian:         'والي',
    dormitory:        'اسرامه',
    studentId:        'نومبور مريد',
    idCard:           'کاد ڤڠنالن',
    gender:           'جنتينا',
    status:           'ستاتوس',
    birthDate:        'تاريخ لاهير',
    age:              'اومور',
    fatherName:       'نام بايه',
    fatherPhone:      'نومبور تليفون بايه',
    motherName:       'نام إيبو',
    motherPhone:      'نومبور تليفون إيبو',
    guardianName:     'نام والي',
    guardianRelation: 'هوبوڠن',
    guardianPhone:    'نومبور تليفون والي',
    dormName:         'اسرامه',
    village:          'کامڤوڠ',
    checkinDate:      'تاريخ ماسوق',
    noDorm:           'تيادا مقيم دي اسرامه',
  },

  attendance: {
    pageTitle:    'ڤريکسا ناما ڤلاجارن',
    noSchedule:   'تيادا جدوال ڤڠاجارن اونتوق هاري اين',
    colPeriod:    'کاب',
    colTime:      'ماس',
    colSubject:   'ماتا ڤلاجرن',
    colClass:     'كلس',
    colGender:    'جنتينا',
    checkBtn:     'ڤريکسا ناما',
  },

  checkAttendance: {
    pageTitle:          'ڤريکسا ناما — بيليک',
    breadcrumb:         'ڤريکسا ناما',
    alreadyChecked:     'سودا ڤريکسا ناما اونتوق کاب اين',
    editLink:           'کليک اونتوق سوڠيت',
    labelDate:          'تاريخ:',
    labelTopic:         'توڤيک:',
    topicPlaceholder:   'اسي توڤيک ڤلاجارن هاري اين',
    saveBtn:            'سيمڤن ڤريکسا ناما',
    saveSuccess:        'جاي ديسيمڤن',
    noStudents:         'تيادا سناراي مريد',
    colId:              'نومبور',
    colName:            'نام-ڤڠکت',
    colStatus:          'ستاتوس',
    statusPresent:      'حاضر',
    statusLate:         'لمبت',
    statusLeave:        'چوتي',
    statusAbsent:       'ڬاڬل حاضر',
    statusWithdrawn:    'جوال',
    errorTitle:         'رالت',
    viewCard:           'کاد',
    viewTable:          'جادول',
  },

  editAttendance: {
    pageTitle:        'سوڠيت ڤريکسا ناما — بيليک',
    breadcrumb:       'ڤريکسا ناما',
    breadcrumbEdit:   (r) => `سوڠيت — بيليک ${r}`,
    labelDate:        'تاريخ:',
    labelTopic:       'توڤيک:',
    topicPlaceholder: 'اسي توڤيک ڤلاجارن',
    saveSuccess:      'جاي ديکمسکيني',
    noData:           'تيادا داتا',
    colId:            'نومبور',
    colName:          'نام-ڤڠکت',
    colStatus:        'ستاتوس',
    saveBtn:          'سيمڤن',
    backBtn:          'کمبالي',
    errorTitle:       'رالت',
  },

  scoreEntry: {
    pageTitle:    'سيمڤن مرک (باهاڬيان اڬام)',
    unsaved:      'اد ڤروبهن يڠ بلوم دسيمڤن',
    studentCount: (n) => `سناراي مريد (${n} ئورڠ)`,
    average:      'ڤوراتا',
    semester1:    'سيميستر 1',
    semester2:    'سيميستر 2',
    total:        'سموا',
    saveBtn:      'سيمڤن مرک',
    saveSuccess:  'جاي ديسيمڤن',
    saveError:    'رالت برلاکو',
    noStudents:   'تيادا سناراي مريد',
    colId:        'نومبور',
    colArabicName:'نام عربي',
    colName:      'نام-ڤڠکت',
  },

  manageTeaching: {
    pageTitle:               'جدول ڤڠاجارن (ڬلوله)',
    classRoom:               'بيليک دارجه',
    filterClass:             'دارجه',
    filterGender:            'جنتينا',
    noRooms:                 'تيادا بيليک دارجه',
    selectRoom:              'ڤيليه بيليک دارجه اونتوک مليهت جدول ڤڠاجارن',
    addTeachingBtn:          'تمبه ڤڠاجارن',
    noTeachings:             'بلوم اد ڤنوڬاسن ڤڠاجارن دالم بيليک اين',
    colCode:                 'کود',
    colSubjectName:          'نام ماتا ڤلاجرن',
    colTeacher:              'ڬورو ڤڠاجار',
    colDayPeriod:            'هاري / کاب',
    assignPeriodTitle:       'تتڤکن کاب',
    addTeachingModalTitle:   'تمبه ڤڠاجارن',
    labelSubject:            'ماتا ڤلاجرن',
    subjectPlaceholder:      '-- ڤيليه ماتا ڤلاجرن --',
    allSubjectsAssigned:     'ماتا ڤلاجرن سموا سوده دتوڬاسکن',
    labelTeacher:            'ڬورو ڤڠاجار',
    teacherPlaceholder:      '-- ڤيليه ڬورو --',
    labelDay:                'هاري',
    dayPlaceholder:          '-- ڤيليه هاري --',
    labelPeriod:             'کاب',
    periodPlaceholder:       '-- ڤيليه کاب --',
    noPeriods:               'بلوم اد کاب دتتڤکن',
    duplicatePeriod:         'کاب اين سوده دتمبه',
    confirmDeleteTitle:      'يکينکن ڤادم؟',
    confirmDeleteBtn:        'ڤادم',
    cancelDeleteBtn:         'باتل',
    deleteFailMsg:           'تيداق دڤات دڤادم',
    errorShort:              'رالت',
  },

  teachingTracking: {
    pageTitle:          'ڤنتاوان ڤڠاجارن',
    classRoom:          'بيليک دارجه',
    noRooms:            'تيادا بيليک دارجه',
    selectRoom:         'ڤيليه بيليک دارجه اونتوک ليهت ستاتوس ڤڠاجارن',
    noTeachings:        'بلوم اد ڤنوڬاسن ڤڠاجارن دالم بيليک اين',
    colCode:            'کود',
    colSubjectName:     'نام ماتا ڤلاجرن',
    colTeacher:         'ڬورو ڤڠاجار',
    colAttSessions:     'کالي ڤريکسا ناما',
    colStudentsScore:   'مريد ميليکي مرک',
    times:              'کالي',
    attendBtn:          'ناما',
    scoreBtn:           'مرک',
    viewLogBtn:         'چاتتن ڤڠاجارن',
  },

  listTeachTracking: {
    pageTitle:    'چاتتن ڤڠاجارن',
    breadHome:    'لامن اوتام',
    breadCurrent: 'چاتتن ڤڠاجارن',
    listTitle:    'سناراي چاتتن',
    countTimes:   (n) => `${n} کالي`,
    noRecords:    'بلوم اد چاتتن ڤڠاجارن',
    colDate:      'تاريخ',
    colTime:      'ماس',
    colPeriod:    'کاب',
    colTopic:     'توڤيک ڤڠاجارن',
    colPresent:   'حاضر',
    colAbsent:    'ڬاڬل',
    colLate:      'لمبت',
    colLeave:     'چوتي',
    colTotal:     'جوملاه',
    noTopic:      'تيادا توڤيک',
  },

  classGrade: {
    pageTitle:     'جدول مرک باهاڬيان اڬام',
    classRoom:     'بيليک دارجه',
    noRooms:       'تيادا بيليک دارجه',
    selectRoom:    'ڤيليه بيليک دارجه اونتوق ليهت مرک',
    tabScores:     'مرک',
    tabAttendance: 'ڤرهاديران',
    noSubjects:    'بلوم اد ماتا ڤلاجرن دلم بيليک اين',
    noAttendance:  'بلوم اد داتا ڤرهاديران',
    colNo:         'نومبور',
    colName:       'نام-ڤڠکت',
    colAverage:    'ڤوراتا',
    colPresent:    'حاضر',
    colAbsent:     'ڬاڬل',
    colLate:       'لمبت',
    colLeave:      'چوتي',
    colTotal:      'جوملاه',
    genderLabel:   (g) => g === 'male' ? 'لاکي-لاکي' : g === 'female' ? 'ڤرمڤوان' : 'جوملاه',
  },

  advisorHome: {
    pageTitle:         'بيليک دارجه سايا (باهاڬيان اڬام)',
    noRoom:            'تيادا بيليک دارجه دالم تاهون ڤلاجارن اين',
    labelStudents:     'مريد',
    labelSubjects:     'ماتا ڤلاجرن',
    cardStudentsTitle: 'سنارائي مريد',
    cardStudentsDesc:  'ليهت سموا مريد دالم بيليک دارجه',
    cardStudentsBtn:   'ليهت مريد',
    cardGradesTitle:   'مرک & ڤرهاديران',
    cardGradesDesc:    'ليهت مرک دان ڤرهاديران مريد',
    cardGradesBtn:     'ليهت مرک',
  },

  advisorGrade: {
    pageTitle:     'مرک & ڤرهاديران',
    noRoom:        'تيادا بيليک دارجه دالم تاهون ڤلاجارن اين',
    tabScores:     'مرک',
    tabAttendance: 'ڤرهاديران',
    noSubjects:    'بلوم اد ماتا ڤلاجرن دالم بيليک اين',
    noAttendance:  'بلوم اد داتا ڤرهاديران',
    colNo:         'نومبور',
    colName:       'نام-ڤڠکت',
    colAverage:    'ڤوراتا',
    colPresent:    'حاضر',
    colAbsent:     'ڬاڬل',
    colLate:       'لمبت',
    colLeave:      'چوتي',
    colTotal:      'جوملاه',
  },

  advisorStudents: {
    pageTitle:     'سنارائي مريد',
    noRoom:        'تيادا بيليک دارجه دالم تاهون ڤلاجارن اين',
    totalStudents: 'جوملاه مريد',
    noStudents:    'بلوم اد مريد دالم بيليک اين',
    colNo:         'نومبور',
    colName:       'نام-ڤڠکت',
    colArabicName: 'نام عربي',
    colGender:     'جنتينا',
  },

  manageRoom: {
    pageTitle:        'ڬلوله بيليک دارجه باهاڬيان اڬام',
    breadHome:        'لامن اوتام',
    breadCurrent:     'بيليک دارجه باهاڬيان اڬام',
    addBtn:           'تمباه بيليک',
    filterAllGender:  '-- سموا جنتينا --',
    filterAllClass:   '-- سموا كلس --',
    listTitle:        'سناراي بيليک دارجه',
    noRooms:          'تيادا داتا بيليک دارجه',
    colClass:         'دارجه',
    colRoom:          'بيليک',
    colGender:        'جنتين',
    colProgram:       'ڤروڬرام',
    colAdvisor:       'ڬورو ناصيحت',
    colStudents:      'مريد',
    modalAddTitle:    'تمباه بيليک دارجه',
    modalEditTitle:   'سوڠيت بيليک دارجه',
    labelClass:       'دارجه',
    classPlaceholder: '-- ڤيليه دارجه --',
    labelRoom:        'بيليک (نومبور بيليک)',
    roomPlaceholder:  'چونتوه 1، 2، A',
    labelGender:      'جنتين مريد',
    labelProgram:     'ڤروڬرام',
    labelAdvisor:     'ڬورو ناصيحت',
    noneOption:       '-- تيادا --',
    incompleteTitle:  'داتا تيداق لڠکاڤ',
    incompleteMsg:    'سيلا اسي نام بيليک، جنتين دان دارجه',
    successTitle:     'برجاي',
    errorTitle:       'رالت',
    successUpdate:    'بيليک دارجه دسوڠيت',
    successAdd:       'بيليک دارجه دتمباه',
    successDelete:    'بيليک دارجه دڤادم',
    confirmDelete:    (r) => `ڤادم بيليک ${r}؟`,
    confirmBtn:       'ڤادم',
    cancelBtn:        'باتل',
    genderLabel:      { m: 'للاکي', f: 'ڤرمڤوان' },
  },

  manageCurriculum: {
    pageTitle:           'ڬلوله سيلابوس باهاڬيان اڬام',
    breadHome:           'لامن اوتام',
    breadCurrent:        'سيلابوس باهاڬيان اڬام',
    syllabusTitle:       'سموا سيلابوس',
    assignedTitle:       'ڤڠاڬيهن سيلابوس',
    addBtn:              'تمباه',
    assignBtn:           'اڬيه',
    colSylYear:          'تاهون سيلابوس',
    noData:              'تيادا داتا',
    colSyllabus:         'سيلابوس',
    colClass:            'دارجه',
    colProgram:          'ڤروڬرام',
    colSubjects:         (n) => `${n} ماتا ڤلاجرن`,
    modalAddSylTitle:    'تمباه سيلابوس',
    labelSylYear:        'تاهون سيلابوس (چونتوه 2567)',
    modalAssignTitle:    'اڬيه سيلابوس',
    labelSyllabus:       'سيلابوس',
    sylPlaceholder:      '-- ڤيليه سيلابوس --',
    labelClass:          'دارجه',
    classPlaceholder:    '-- ڤيليه دارجه --',
    labelProgram:        'ڤروڬرام',
    noneOption:          '-- تيادا --',
    successTitle:        'برجاي',
    errorTitle:          'رالت',
    incompleteTitle:     'داتا تيداق لڠکاڤ',
    confirmBtn:          'ڤادم',
    cancelBtn:           'باتل',
    addedSyl:            'سيلابوس دتمباه',
    deletedSyl:          'سيلابوس دڤادم',
    confirmDeleteSyl:    (y) => `ڤادم سيلابوس تاهون ${y}؟`,
    assignedSuccess:     'سيلابوس دياڬيه',
    cancelledAssign:     'ڤڠاڬيهن دباتلکن',
    confirmCancelAssign: 'باتلکن ڤڠاڬيهن سيلابوس؟',
    incompleteAssignMsg: 'سيلا ڤيليه سيلابوس دان دارجه',
  },

  manageSubject: {
    pageTitle:        'ڬلوله ماتا ڤلاجرن باهاڬيان اڬام',
    breadHome:        'لامن اوتام',
    breadSyllabus:    'سيلابوس',
    breadCurrent:     'ماتا ڤلاجرن',
    addBtn:           'تمباه ماتا ڤلاجرن',
    listTitle:        (n) => `ماتا ڤلاجرن (${n})`,
    noSubjects:       'بلوم اد ماتا ڤلاجرن',
    colCode:          'کود ماتا ڤلاجرن',
    colName:          'نام ماتا ڤلاجرن',
    modalAddTitle:    'تمباه ماتا ڤلاجرن',
    modalEditTitle:   'سوڠيت ماتا ڤلاجرن',
    labelCode:        'کود ماتا ڤلاجرن',
    codePlaceholder:  'چونتوه IS101',
    labelName:        'نام ماتا ڤلاجرن',
    namePlaceholder:  'نام ماتا ڤلاجرن',
    incompleteTitle:  'داتا تيداق لڠکاڤ',
    incompleteMsg:    'سيلا اسي کود دان نام ماتا ڤلاجرن',
    successTitle:     'برجاي',
    errorTitle:       'رالت',
    successUpdate:    'ماتا ڤلاجرن دسوڠيت',
    successAdd:       'ماتا ڤلاجرن دتمباه',
    successDelete:    'ماتا ڤلاجرن دڤادم',
    confirmDelete:    (c) => `ڤادم ماتا ڤلاجرن ${c}؟`,
    confirmBtn:       'ڤادم',
    cancelBtn:        'باتل',
  },

  manageStudents: {
    pageTitle:          (r) => `مريد دلم بيليک ${r}`,
    breadHome:          'لامن اوتام',
    breadRooms:         'بيليک دارجه',
    breadCurrent:       'مريد',
    filterAllClass:     '-- كلس --',
    filterAllGender:    '-- جنتينا --',
    filterAllRoom:      '-- بيليک --',
    selectRoom:         'سيلا ڤيليه بيليک دارجه دري سنارائي دياتس',
    addStudentTitle:    'تمباه مريد',
    labelStudentId:     'نومبور مريد',
    searchPlaceholder:  'اسي نومبور مريد',
    notFound:           (id) => `مريد نومبور ${id} تيداق جومڤا`,
    enrollBtn:          'دفتر مسوق بيليک اين',
    searchHint:         'چاري دڠن نومبور مريد کمودين تيکن دفتر',
    listTitle:          (n) => `سناراي مريد (${n} ئورڠ)`,
    noStudents:         'بلوم اد مريد دلم بيليک اين',
    colNo:              'نومبور',
    colName:            'نام-ڤڠکت',
    colArabicName:      'نام عرب',
    colGender:          'جنتين',
    colStatus:          'ستاتوس',
    statusBadge:        { 0: 'کلوار', 1: 'سدڠ بلاجر', 3: 'مريد بارو' },
    noInfo:             'تيادا ماکلومت',
    genderLabel:        (g) => g === 'm' ? 'لاکي-لاکي' : 'ڤرمڤوان',
    labelGender:        'جنتين',
    labelStatus:        'ستاتوس',
    confirmUnenroll:    (name) => `تاريق ${name} دري بيليک؟`,
    successTitle:       'برجاي',
    errorTitle:         'رالت',
    enrolledSuccess:    'مريد ديدفترکن',
    unenrolledSuccess:  'مريد دتاريق',
    confirmUnenrollBtn: 'تاريق',
    cancelBtn:          'باتل',
  },
}
